import { GlobalAxios } from "../axios/axios-config";
import { ITasyProvider } from "../models/tasy-provider";

const PROVIDER_ROUTE = process.env.REACT_APP_EXTERNAL + "/api/v1/Provider/Provider";

export const providerList = (params?: any) => {
  return GlobalAxios.get<ITasyProvider[]>(PROVIDER_ROUTE, {
    params,
  });
};
